(function() {
    angular
        .module("app")
        .controller("ApiRequestAccessController", ApiRequestAccessController)

        ApiRequestAccessController.$inject = [
        "$scope",
        "$uibModalInstance"
    ]

    function ApiRequestAccessController(
        $scope,
        $uibModalInstance
    ){
        "use strict"

        $scope.close = () => {
            $uibModalInstance.dismiss("cancel")
        }

    }
})()
